<template>
  <div class="tabs">
    <div class="d-flex" v-for="(item, index) in creditCardList" :key="index">
      <input
        type="checkbox"
        v-if="displayList(item.availableCard, item.isShow)"
        :checked="false"
        :id="tabIndex(index)"
        :data-testid="tabIndex(index)"
      />
      <div class="tab" v-if="displayList(item.availableCard, item.isShow)">
        <div class="tab-title">
          <el-row type="flex" justify="space-between">
            <el-col class="flex_start" :xs="24" :sm="14" :md="12" :lg="10">
              <div class="type_Img" v-if="[4, 5].includes(getFirstNum(item.creditCard.card_begin_six_digits))">
                <img :src="creditCardImg[getFirstNum(item.creditCard.card_begin_six_digits)]" alt />
              </div>
              <div class="label">{{ $t('common.withdrawChannel.creditcard') }}</div>
              <el-select
                v-model="form[`form_${index}`]"
                :disabled="disabledSelect"
                :data-testid="`form_${index}`"
                @change="updateCcForm(index)"
              >
                <el-option
                  v-for="(list, i) in item.selectedCardList"
                  v-show="list.availableCard"
                  :key="i + index"
                  :value="i + index"
                  :label="setCreditCardNumber(list.creditCard)"
                  :data-testid="i + index"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="{ span: 3, offset: 4 }">
              <div class="label">{{ $t('common.field.amt') }}</div>
              <div class="label">${{ item.showBalance }}</div>
            </el-col>
            <el-col :xs="1" :sm="1" class="justify-content-center">
              <el-button class="white_button" @click="showArchiveCardDialog = true" v-if="archivable(item)">
                {{ $t('common.withdrawChannel.archive') }}
              </el-button>
            </el-col>
            <el-col :xs="1" :sm="1" class="justify-content-center">
              <template v-if="creditCardCanEdit(item)">
                <label :for="tabIndex(index)" :data-testid="`label${index}`"> <div class="arrow"></div> </label>
              </template>
            </el-col>
          </el-row>
        </div>
        <div class="tab-content">
          <CreditCardWithdraw
            :ref="'creditCardWithdraw' + index"
            :ccDetail="item"
            :creditCardNumber="setCreditCardNumber(item.selectedCardList[0].creditCard)"
            :archivable="item.creditCard.is_del === 0 && !item.isPending"
            :isExpired="item.isExpired"
          ></CreditCardWithdraw>
        </div>
      </div>
      <WithdrawArchiveCardDialog :visible.sync="showArchiveCardDialog" :ccDetail="item"></WithdrawArchiveCardDialog>
    </div>
  </div>
</template>

<script>
import CreditCardWithdraw from './CreditCardWithdraw';
import WithdrawArchiveCardDialog from '@/components/withdraw/WithdrawArchiveCardDialog.vue';

export default {
  name: 'ccTab',
  components: { CreditCardWithdraw, WithdrawArchiveCardDialog },
  props: {
    creditCardList: {
      type: Array,
      default: () => []
    },
    form: {
      type: Object,
      default: () => {}
    },
    showAvailable: {
      type: Boolean,
      default: true
    },
    amount: Number,
    disableField: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      creditCardImg: {
        4: require('@/assets/images/withdraw/visa.png'),
        5: require('@/assets/images/withdraw/master_card.png')
      },
      showArchiveCardDialog: false
    };
  },
  computed: {
    disabledSelect() {
      if (!this.showAvailable) {
        return true;
      }
      return this.disableField;
    }
  },
  methods: {
    updateCcForm(index) {
      this.$emit('updateCcForm', index);
    },
    setCreditCardNumber(creditCard) {
      this.firstCreditCardNum = parseInt(creditCard.card_begin_six_digits.split('')[0]);
      return `${creditCard.card_begin_six_digits}** ****${creditCard.card_last_four_digits}`;
    },
    displayList(availableCard, isShow) {
      if (this.showAvailable) {
        return availableCard && isShow;
      }
      return !availableCard;
    },
    tabIndex(index) {
      return this.showAvailable ? `tab${index}` : `tab-unavailable-${index}`;
    },
    getFirstNum(val) {
      return parseInt(val.split('')[0]);
    },
    creditCardCanEdit(item) {
      // 如果信用卡有效期為空，回傳 true 顯示編輯按鈕
      if (!(item.creditCard.expiry_month && item.creditCard.expiry_year)) {
        return true;
      }
      return !this.showAvailable;
    },
    archivable(item) {      
      return item.creditCard.is_del === 0 && !item.isPending && !item.hasRecentRecord;
    },
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/withdraw/ccMethod.scss';
</style>
